import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal } from 'antd';
import cn from 'classnames';
import { MdDelete } from 'react-icons/md';
import { useFieldArrayMethods } from '../../../../helpers/formManager';
import styles from './index.module.scss';

const { confirm } = Modal;

const RemoveFieldset = ({ createConfirmData, action }) => {
  const { remove } = useFieldArrayMethods();
  const dispatch = useDispatch();

  const handleClick = () => {
    const { index, title, onAfterRemove } = createConfirmData();

    confirm({
      title: title || 'Вы уверены, что хотите удалить?',
      onOk: () => {
        remove(index, ({ fieldCount }) => {
          if (typeof onAfterRemove === 'function') {
            onAfterRemove();
          }

          if (fieldCount === 0) {
            dispatch(action(undefined));
            return;
          }

          if (fieldCount <= index) {
            dispatch(action(fieldCount - 1));
            return;
          }
        });
      },
      onCancel: () => {},
    });
  };

  return (
    <Button
      type="danger"
      ghost
      className={cn(styles.root, 'ant-btn-icon-only')}
      onClick={handleClick}
    >
      <MdDelete />
    </Button>
  );
};

export default RemoveFieldset;
